// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper--rW0Wr","reset":"reset--iZW0G"};